/**
 * Parentesco (para la declaración PEP). Valores de DOMINIO legibles (ADR D003):
 * el código que exige la IVE/SES (`P`, `M`, `HJ`…) NO vive aquí — vive en el mapper
 * anti-corrupción del lado API, que traduce sólo al exportar a la IVE.
 * Ver docs/architecture/patterns/ive-codes-anti-corruption.md.
 */
export const Relationship = {
  FATHER: 'FATHER',
  MOTHER: 'MOTHER',
  CHILD: 'CHILD',
  SIBLING: 'SIBLING',
  SPOUSE: 'SPOUSE',
  OTHER: 'OTHER'
} as const

export type Relationship = (typeof Relationship)[keyof typeof Relationship]

export const RelationshipLabel = {
  [Relationship.FATHER]: 'Padre',
  [Relationship.MOTHER]: 'Madre',
  [Relationship.CHILD]: 'Hijo/a',
  [Relationship.SIBLING]: 'Hermano/a',
  [Relationship.SPOUSE]: 'Cónyuge',
  [Relationship.OTHER]: 'Otro'
} as const satisfies Record<Relationship, string>
